import React from "react";
import useFilterSidebar from "./useFilterSidebar";
import { Checkbox, Collapse } from "antd";
import Button from "../../../ui/Button";
// svgs
import { ReactComponent as CancelIcon } from "../../../../../assets/svg/second-cancel.svg";
import { ReactComponent as BottomArrowIcon } from "../../../../../assets/svg/bottom-arrow.svg";

const FilterSidebar = (props) => {
  const {
    filter_open,
    set_filter_open,
    filter_list = [],
    checkbox_change,
    clear_filter,
    submit_filter,
  } = props;

  const [sidebar_ref] = useFilterSidebar(filter_open, set_filter_open);

  return (
    <div className={`filter-sidebar-responsive ${filter_open ? "active": ""}`}>
      <div
        className={`filter-sidebar-backdrop ${filter_open ? "active" : ""}`}
      />

      <div
        ref={sidebar_ref}
        className={`filter-sidebar ${filter_open ? "active" : ""}`}>
        <div className={"filter-sort-top-nav"}>
          <div
            onClick={() => set_filter_open(false)}
            className={"cancel-icon-wrapper"}>
            <CancelIcon />
          </div>
        </div>
        <div className={"collapse-container-parent"}>
          <Collapse
            className={"collapse-container"}
            expandIcon={({ isActive }) => <BottomArrowIcon className="custom-icon-collapse" transform={`rotate(${isActive ? 180 : 0})`} width="10px" height="10px" />}>
            {filter_list.map((filter_item, filter_item_index) => {
              if (filter_item.type === "collapse") {
                return (
                  <Collapse.Panel
                    key={filter_item.id}
                    className={"collapse-panel"}
                    header={filter_item.label}>
                    <div className={"checkboxes-container"}>
                      {filter_item.list.map((sub_item, sub_item_index) => (
                        <Checkbox
                          checked={sub_item.active}
                          className={"checkbox-style"}
                          onChange={(e) => {
                            checkbox_change(
                              filter_item_index,
                              sub_item_index,
                              e.target.checked
                            );
                          }}>
                          {sub_item.label}
                        </Checkbox>
                      ))}
                    </div>
                  </Collapse.Panel>
                );
              }
              return null;
            })}
          </Collapse>
        </div>
        <div className={"submit-filter-button-container"}>
          <Button
            style_width={"49%"}
            style_backgroundColor="unset"
            style_background="linear-gradient(0deg, #FF0000, #FF0000), linear-gradient(0deg, #FF4500, #FF4500)"
            style_fontSize="type-2"
            style_fontWeight="bold"
            style_borderRadius="type-2"
            onClick={() => clear_filter()}
            >
            Reset
          </Button>
          <Button
            style_width="49%"
            style_fontSize={"type-2"}
            style_fontWeight="bold"
            style_borderRadius="type-2"
            onClick={() => submit_filter()}
            >
            Filter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;
